import React from "react";
import "./Footer.css";
import {
  FiMail,
  FiMapPin,
  FiClock,
  FiPhone,
  FiTwitter,
  FiInstagram,
  FiLinkedin,
  FiFacebook,
} from "react-icons/fi";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-brand">
          <NavLink to="/" className="footer-logo logo-brand">
            <div className="logo-icon-wrapper">
              <img src="/new-logo.png" alt="XHT Icon" />
            </div>
            <div className="logo-text">
              <span className="brand-primary">Xperts</span>
              <span className="brand-accent">House Tech</span>
            </div>
          </NavLink>
          <p className="brand-desc">
            Architecting the future of technology with precision engineering and
            visionary design. We empower businesses to scale in the digital age.
          </p>
          <div className="social-links">
            <a
              href="https://x.com/couponsspot338"
              className="social-icon"
              target="_blank"
              rel="noreferrer"
            >
              <FiTwitter />
            </a>
            <a
              href="mailto:hr@xpertstech.net"
              className="social-icon"
            >
              <FiInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/xperts-house-technology/"
              className="social-icon"
              target="_blank"
              rel="noreferrer"
            >
              <FiLinkedin />
            </a>
            <a
              href="https://www.facebook.com/share/17ZuCcwZ1L/"
              className="social-icon"
              target="_blank"
              rel="noreferrer"
            >
              <FiFacebook />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h3 className="footer-title">Navigation</h3>
          <ul>
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/servicespage">Our Services</NavLink>
            </li>
            <li>
              <NavLink to="/about">About Agency</NavLink>
            </li>
            <li>
              <NavLink to="/contactus">Contact Hub</NavLink>
            </li>
          </ul>
        </div>

        <div className="footer-links">
          <h3 className="footer-title">Expertise</h3>
          <ul>
            <li>
              <NavLink to="/blockChain">Web3 & Blockchain</NavLink>
            </li>
            <li>
              <NavLink to="/webdevelopment">Enterprise Web</NavLink>
            </li>
            <li>
              <NavLink to="/game">Game Engineering</NavLink>
            </li>
            <li>
              <NavLink to="/mobileapp">Mobile Innovation</NavLink>
            </li>
            <li>
              <NavLink to="/marketing">Growth Marketing</NavLink>
            </li>
          </ul>
        </div>

        <div className="footer-links contact-col">
          <h3 className="footer-title">Contact Hub</h3>
          <ul className="footer-contact">
            <li>
              <span className="icon-circle">
                <FiMapPin />
              </span>
              <span>Gulberg III, Lahore, PK</span>
            </li>
            <li>
              <span className="icon-circle">
                <FiMail />
              </span>
              <span>hr@xpertstech.net</span>
            </li>
            <li>
              <span className="icon-circle">
                <FiPhone />
              </span>
              <span>+923003967143</span>
            </li>
            <li>
              <span className="icon-circle">
                <FiClock />
              </span>
              <span>Mon - Sat: 9 AM - 8 PM</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="bottom-content">
          <p>© {currentYear} Xperts House Technology. All rights reserved.</p>
          <div className="bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
